/* @flow */

import React from 'react';
// $FlowIgnore
import { Link } from 'react-router';

import type { ParamsLinkProps } from './types';
import { stringify } from "qs";
import withRouting from 'utils/withRouting';

function ParamsLink({
  router, query, style, children, customDataTestID, includeCurrentParams = true,
}: ParamsLinkProps): React.Element {
  return (
    <Link
      data-testid={customDataTestID}
      style={style}
      to={{
        search: stringify({
          ...(includeCurrentParams ? router.location.query : {}),
          ...query,
        })
      }}
    >
      {children}
    </Link>
  );
}


export default withRouting(ParamsLink);
